import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      cursor: 'pointer',
      justifyContent: 'center',
      gap: '8px',
      '& img': {
        width: '100%',
        boxSizing: 'border-box',
      },
    },
    imageWrap: {
      backgroundColor: colors.white_20,
      display: 'flex',
      alignItems: 'center',
      borderRadius: '50%',
      overflow: 'hidden',
    },
    title: {
      fontWeight: 500,
      fontSize: 13,
      lineHeight: '13px',
      letterSpacing: '0.1px',
      color: colors.white,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 12,
      },
    },
  };
};
